module.exports = __webpack_public_path__ + "static/joc_01-f055f1fc9bf39ae5a4174a11d70a7b84.jpg";